<template>
  <div v-if="editTaskCard" class="w-100">
    <proa-card v-if="taskCard" class="h-100 d-flex flex-column" no-padding>
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center">
          <proa-back-button
            @onClick="onClickBackButton"
          />
          <proa-heading class="task-title" detail>{{ taskCard.title }}</proa-heading>
          <div class="d-flex align-items-center">
            <div
              v-click-outside="() => { displayingTaskCardEditMenu = false }"
              class="task-card-item"
              @click="displayingTaskCardEditMenu = !displayingTaskCardEditMenu"
            >
              <img :src="require('@/assets/images/icons/ellipsis.png')" />
              <div
                v-show="displayingTaskCardEditMenu"
                class="task-card-edit-menu"
              >
                <!-- <div
                  @click="$router.push({ name: 'editProjectTaskCards', params: { projectId: projectId, id: taskCardId } })"
                  class="menu"
                >
                  {{ $t('pages.project.taskCards.show.editTaskCard') }}
                </div> -->
                <div
                  @click="deleteTaskCardModal = true"
                  class="menu"
                >
                  {{ $t('pages.project.taskCards.show.deleteTaskCard') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="task-card-content-wrapper">
        <div class="task-card-content">
          <div class="task-card-flex-container">
            <div class="task-card-flex-item">
              <div class="table-attributes-wrapper">
                <table class="table-attributes">
                  <tbody>
                    <tr>
                      <th valign="top" @click="editTitleModal = true">
                        <span>
                          <img :src="require('@/assets/images/icons/edit.png')">
                          {{ $t('models.taskCard.attributes.title') }}
                        </span>
                      </th>
                      <td>
                        <span :class="['attribute', { 'empty': !editTaskCard.title }]">{{ editTaskCard.title }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th @click="editTaskListIdModal = true">
                        <span>
                          <img :src="require('@/assets/images/icons/edit.png')" @click="editTaskListIdModal = true">
                          {{ $t('models.taskCard.attributes.taskListId') }}
                        </span>
                      </th>
                      <td>
                        <span :class="['attribute', { 'empty': !editTaskCard.taskListId }]">{{ selectedTaskListTitle(editTaskCard.taskListId) || $t('models.taskCard.placeHolders.taskListId') }}</span>
                      </td>
                    </tr>
                    <tr>
                      <th @click="editPeriodModal = true">
                        <span>
                          <img :src="require('@/assets/images/icons/edit.png')" @click="editPeriodModal = true">
                          {{ $t('models.taskCard.period') }}
                        </span>
                      </th>
                      <td>
                        <span v-if="!editTaskCard.startAt && !editTaskCard.endAt">{{ $t('models.taskCard.placeHolders.period') }}</span>
                        <span v-else :class="{ 'overdue': overdue }">
                          {{ editTaskCard.startAt | moment('YYYY年MM月DD日（ddd）') }} 〜 {{ editTaskCard.endAt | moment('YYYY年MM月DD日（ddd）') }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th @click="editProgressModal = true">
                        <span>
                          <img :src="require('@/assets/images/icons/edit.png')" @click="editProgressModal = true">
                          {{ $t('models.taskCard.attributes.progress') }}
                        </span>
                      </th>
                      <td>
                        <span :class="{ 'overdue': overdue }">
                          {{ editTaskCard.progress }}%
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th @click="editProjectLabelIdsModal = true">
                        <span>
                          <img :src="require('@/assets/images/icons/edit.png')" @click="editProjectLabelIdsModal = true">
                          {{ $t('models.taskCard.attributes.projectLabelIds') }}
                        </span>
                      </th>
                      <td>
                        <span v-if="editTaskCard.projectLabelIds.length">
                          <proa-project-label
                            v-for="projectLabel in editTaskCard.projectLabelIds"
                            :key="projectLabel.id"
                            :title="selectedProjectLabel(projectLabel).title"
                            :color="selectedProjectLabel(projectLabel).color"
                          />
                        </span>
                        <span v-else>
                          {{ $t('models.taskCard.placeHolders.projectLabelIds') }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th valign="top" @click="editDescriptionModal = true">
                        <span>
                          <img :src="require('@/assets/images/icons/edit.png')" @click="editDescriptionModal = true">
                          {{ $t('models.taskCard.attributes.description') }}
                        </span>
                      </th>
                      <td class="text-pre-wrap">
                        <span
                          v-html="editTaskCard.description ? $options.filters.autoLink(editTaskCard.description) : $t('models.taskCard.placeHolders.description')"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('models.taskCard.users') }}（{{ editTaskCard.userIds.length }}{{ $t('common.person') }}）</th>
                      <td>
                        <proa-button
                          @click.native="addTaskCardMembersModal = true"
                          class="default-button-width add-member-button"
                        >
                          {{ $t('common.addMember') }}
                        </proa-button>
                        <proa-button
                          :disabled="editTaskCard.userIds.length == 0"
                          @click.native="deleteTaskCardMembersModal = true"
                          class="default-button-width"
                        >
                          {{ $t('common.deleteMember') }}
                        </proa-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="members">
                  <div class="members-scroll-wrapper">
                    <div v-for="user in addedUsers" :key="user.id" class="member">
                      <proa-avatar :src="user.meta.avatar || require('@/assets/images/avatar_default.png')" size="sm"/>
                      <span class="ml-2 pl-1">{{ user.meta.displayName }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="task-card-related-information">
          <div class="tab-wrapper">
            <div
              :class="['tab-menu', { 'active': relatedInformation === 'histories' }]"
              @click="relatedInformation = 'histories'"
            >
              <span>{{ $t('pages.project.taskCards.show.taskCardHistories') }}</span>
            </div>
            <div
              :class="['tab-menu', { 'active': relatedInformation === 'chat' }]"
              @click="relatedInformation = 'chat'"
            >
              <span>{{ $t('pages.project.taskCards.show.taskCardChat') }}</span>
              <span v-if="projectChatPosts.length">（{{ projectChatPostsPagination.count }}）</span>
            </div>
          </div>
          <div class="menu-wrapper">
            <div v-show="relatedInformation === 'chat'" class="chat-posts-flex-container">
              <div class="posts-flex-item">
                <div class="posts-wrapper" ref="postsWrapper">
                  <div
                    v-for="projectChatPost in projectChatPosts"
                    :key="projectChatPost.id"
                    class="post"
                  >
                    <group-chat-post-content
                      :groupChatPost="projectChatPost"
                      :taskCardPreview="true"
                    />
                  </div>
                  <div class="post-loading blink"
                    v-if="projectChatPostsPagination.next"
                    ref="postLoading"
                  >
                    {{ $t('common.postLoading') }}
                  </div>
                </div>
              </div>
            </div>
            <div v-show="relatedInformation === 'histories'" class="histories-flex-container">
              <div class="histories-flex-item">
                <div class="histories-wrapper" ref="historiesWrapper">
                  <div
                    v-for="taskCardHistory in taskCardHistories"
                    :key="taskCardHistory.id"
                    class="task-card-history"
                  >
                    <task-card-history-content
                      :taskCardHistory="taskCardHistory"
                      :projectLabels="project.projectLabels"
                    />
                  </div>
                  <div class="history-loading blink"
                    v-if="taskCardHistoriesPagination.next"
                    ref="historyLoading"
                  >
                    {{ $t('common.historyLoading') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="['edit-task-card-card-footer', {'display-card-footer': !toCompareAllValue}]"
      >
        <proa-button
          class="mr-2 default-button-width"
          @click.native="onCancelUpdate"
        >
          {{ $t('common.cancel') }}
        </proa-button>
        <proa-button
          :disabled="!validated"
          :loading="updateTaskCardRequesting"
          variant="primary"
          class="default-button-width"
          @click.native="onClickUpdateTaskCard"
        >
          {{ $t('common.update') }}
        </proa-button>
      </div>
    </proa-card>
    <proa-modal
      v-if="taskCard"
      :modal="deleteTaskCardModal"
      :title="$t('common.confirm')"
      @close="() => { if (!deleteTaskCardRequesting) { deleteTaskCardModal = false } }"
    >
      <proa-heading sub>{{ $t('common.modals.deleteTaskCardModal.confirmMessage') }}</proa-heading>
      <template v-slot:footer>
        <proa-button
          @click.native="deleteTaskCardModal = null"
          :disabled="deleteTaskCardRequesting"
          class="mr-2"
        >
          {{ $t('common.cancel') }}
        </proa-button>
        <proa-button
          @click.native="onConfirmedDeleteTaskCard"
          :loading="deleteTaskCardRequesting"
          variant="secondary"
        >
          {{ $t('common.delete') }}
        </proa-button>
      </template>
    </proa-modal>
    <edit-title-modal
      :modal="editTitleModal"
      :title="editTaskCard.title"
      @close="editTitleModal = false"
      @onUpdateTitle="onUpdateTitle"
    />
    <edit-task-list-id-modal
      :modal="editTaskListIdModal"
      :taskListId="editTaskCard.taskListId"
      :taskLists="taskLists"
      @close="editTaskListIdModal = false"
      @onUpdateTaskListId="onUpdateTaskListId"
    />
    <edit-period-modal
      :modal="editPeriodModal"
      :startAt="editTaskCard.startAt"
      :endAt="editTaskCard.endAt"
      @close="editPeriodModal = false"
      @onUpdatePeriod="onUpdatePeriod"
    />
    <edit-progress-modal
      :modal="editProgressModal"
      :progress="editTaskCard.progress"
      @close="editProgressModal = false"
      @onUpdateProgress="onUpdateProgress"
    />
    <edit-project-label-check-box-modal
      :modal="editProjectLabelIdsModal"
      :projectLabelIds="editTaskCard.projectLabelIds"
      :projectLabels="this.projectLabels"
      @close="editProjectLabelIdsModal = false"
      @onUpdateProjectLabelIds="onUpdateProjectLabelIds"
    />
    <edit-description-modal
      :modal="editDescriptionModal"
      :description="editTaskCard.description"
      @close="editDescriptionModal = false"
      @onUpdateDescription="onUpdateDescription"
    />
    <select-member-modal
      :modal="addTaskCardMembersModal"
      :designated="true"
      :userIds="editTaskCard.userIds"
      :designatedUserIds="project.userIds"
      type="add"
      @close="addTaskCardMembersModal = false"
      @confirm="addUserIds"
    />
    <select-member-modal
      :modal="deleteTaskCardMembersModal"
      :designated="true"
      :userIds="editTaskCard.userIds"
      type="delete"
      @close="deleteTaskCardMembersModal = false"
      @confirm="deleteUserIds"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ClickOutside from 'vue-click-outside'

import GroupChatPost from '@/store/models/GroupChatPost'
import Project from '@/store/models/Project'
import TaskCard from '@/store/models/TaskCard'
import TaskCardHistory from '@/store/models/TaskCardHistory'
import TaskList from '@/store/models/TaskList'
import User from '@/store/models/User'

import GroupChatPostContent from '@/components/organisms/GroupChatPostContent'
import TaskCardHistoryContent from '@/components/organisms/TaskCardHistoryContent'

import EditTitleModal from '@/components/molecules/project/taskCards/EditTitleModal'
import EditTaskListIdModal from '@/components/molecules/project/taskCards/EditTaskListIdModal'
import EditPeriodModal from '@/components/molecules/project/taskCards/EditPeriodModal'
import EditProgressModal from '@/components/molecules/project/taskCards/EditProgressModal'
import EditProjectLabelCheckBoxModal from '@/components/molecules/project/taskCards/EditProjectLabelCheckBoxModal'
import EditDescriptionModal from '@/components/molecules/project/taskCards/EditDescriptionModal'
import SelectMemberModal from '@/components/organisms/SelectMemberModal'

export default {
  name: 'ShowProjectTaskCards',
  components: {
    EditTitleModal,
    EditTaskListIdModal,
    EditPeriodModal,
    EditProgressModal,
    EditProjectLabelCheckBoxModal,
    EditDescriptionModal,
    SelectMemberModal,
    GroupChatPostContent,
    TaskCardHistoryContent
  },
  directives: {
    ClickOutside
  },
  computed: {
    returnMenu: function() { return this.$route.params.returnMenu },
    projectId: function() { return this.$route.params.projectId },
    taskCardId: function() { return this.$route.params.id },
    project: function() { return Project.find(this.projectId) },
    projectLabels: function() { return this.project.projectLabels },
    projectChatPosts: function() {
      return GroupChatPost.query().where('taskCardId', this.taskCardId).orderBy('createdAt', 'desc').get()
    },
    taskCard: function() { return TaskCard.find(this.taskCardId) },
    taskCardHistories: function() {
      return TaskCardHistory.query().where('taskCardId', Number(this.taskCardId)).orderBy('createdAt', 'desc').get()
    },
    taskLists: function() {
      return TaskList.query().where((taskList) => {
        return taskList.projectId == this.projectId && taskList.listType != 'archive'
      }).orderBy('listIndex', 'asc').get()
    },
    selectedTaskListTitle: function() {
      return function(taskListId) {
        return TaskList.find(taskListId)?.title || ''
      }
    },
    selectedProjectLabel: function() {
      return function(projectLabelId) {
        return this.projectLabels.filter(projectLabel => projectLabel.id == projectLabelId)[0]
      }
    },
    addedUsers: function() {
      return User.findIn(this.editTaskCard.userIds)
    },
    overdue: function() {
      return this.taskCard.progress != 100 && moment(this.taskCard.endAt).isSameOrBefore(moment(new Date()))
    },
    validated: function() {
      return this.editTaskCard.title && this.editTaskCard.taskListId
    },
    toCompareTaskTitle: function () {
      return this.editTaskCard.title === this.taskCard.title
    },
    toCompareTaskList: function () {
      return this.editTaskCard.taskListId === this.taskCard.taskListId
    },
    toCompareTaskPeriod: function () {
      let formatEditTaskCardSt = moment(this.editTaskCard.startAt)
      let formatTaskCardSt = moment(this.taskCard.startAt)
      let formatEditTaskCardEn = moment(this.editTaskCard.endAt)
      let formatTaskCardEn = moment(this.taskCard.endAt)

      return formatEditTaskCardSt.format('YYYY-MM-DD') === formatTaskCardSt.format('YYYY-MM-DD') &&
              formatEditTaskCardEn.format('YYYY-MM-DD') === formatTaskCardEn.format('YYYY-MM-DD')
    },
    toCompareTaskProgress: function () {
      return this.editTaskCard.progress === this.taskCard.progress
    },
    toCompareTaskProjectLabel: function () {
      return this.editTaskCard.projectLabelIds.length === this.taskCard.projectLabelIds.length &&
        this.editTaskCard.projectLabelIds.filter((projectLabelId) => this.taskCard.projectLabelIds.indexOf(projectLabelId) === -1).length === 0
    },
    toCompareDescription: function () {
      return this.editTaskCard.description === this.taskCard.description
    },
    toCompareTaskMembers: function () {
      return this.editTaskCard.userIds.length === this.taskCard.userIds.length
    },
    toCompareAllValue: function () {
      return this.toCompareTaskTitle &&
        this.toCompareTaskList &&
        this.toCompareTaskPeriod &&
        this.toCompareTaskProgress &&
        this.toCompareTaskProjectLabel &&
        this.toCompareDescription &&
        this.toCompareTaskMembers
    },
    ...mapGetters({
      httpError: 'httpError',
      projectChatPostsPagination: 'projectChatPosts/pagination',
      taskCardHistoriesPagination: 'entities/taskCardHistories/pagination'
    })
  },
  data() {
    return {
      editTaskCard: null,
      editTitleModal: false,
      editTaskListIdModal: false,
      editPeriodModal: false,
      editProgressModal: false,
      editProjectLabelIdsModal: false,
      editDescriptionModal: false,
      addTaskCardMembersModal: false,
      deleteTaskCardMembersModal: false,
      displayingTaskCardEditMenu: false,
      deleteTaskCardModal: false,
      deleteTaskCardRequesting: false,
      isPostsLoading: false,
      isHistoriesLoading: false,
      updateTaskCardRequesting: false,
      relatedInformation: 'histories'
    }
  },
  methods: {
    onUpdateTitle: function(title) {
      this.editTaskCard.title = title
      this.editTitleModal = false
    },
    onUpdateTaskListId: function(taskListId) {
      this.editTaskCard.taskListId = Number(taskListId)
      this.editTaskListIdModal = false
    },
    onUpdatePeriod: function(startAt, endAt) {
      this.editTaskCard.startAt = startAt
      this.editTaskCard.endAt = endAt
      this.editPeriodModal = false
    },
    onUpdateProgress: function(progress) {
      this.editTaskCard.progress = Number(progress)
      this.editProgressModal = false
    },
    onUpdateProjectLabelIds: function(projectLabelIds) {
      if (projectLabelIds[0] == null) {
        this.editTaskCard.projectLabelIds = []
      } else {
        this.editTaskCard.projectLabelIds = projectLabelIds
      }
      this.editProjectLabelIdsModal = false
    },
    onUpdateDescription: function(description) {
      this.editTaskCard.description = description
      this.editDescriptionModal = false
    },
    addUserIds: function({ userIds }) {
      this.addTaskCardMembersModal = false
      this.editTaskCard.userIds = this.editTaskCard.userIds.concat(userIds)
    },
    deleteUserIds: function({ userIds }) {
      this.deleteTaskCardMembersModal = false
      this.editTaskCard.userIds = this.editTaskCard.userIds.filter(userId => !userIds.includes(userId))
    },
    onCancelUpdate: function () {
      this.editTaskCard = Object.assign(TaskCard.skeleton(), this.taskCard)
    },
    onClickBackButton: function() {
      this.$router.push({ name: 'showProject', params: {
        id: this.projectId,
        defaultMenu: this.returnMenu
      }})
    },
    async onScrollHistoriesWrapper() {
      if (!this.$refs.historyLoading || this.isHistoriesLoading) return
      if (Math.abs(this.$refs.historiesWrapper.scrollTop - this.$refs.historyLoading.offsetTop) - this.$refs.historiesWrapper.offsetHeight < 20) {
        this.isHistoriesLoading = true
        await this.apiGetTaskCardHistories({
          projectId: this.projectId,
          taskCardId: this.taskCardId,
          page: this.taskCardHistoriesPagination.next
        })
        this.isHistoriesLoading = false
      }
    },
    async onScrollPostsWrapper() {
      if (!this.$refs.postLoading || this.isPostsLoading) return
      if (Math.abs(this.$refs.postsWrapper.scrollTop - this.$refs.postLoading.offsetTop) - this.$refs.postsWrapper.offsetHeight < 20) {
        this.isPostsLoading = true
        await this.apiGetProjectChatPosts({
          projectId: this.projectId,
          taskCardId: this.taskCardId,
          page: this.projectChatPostsPagination.next
        })
        this.isPostsLoading = false
      }
    },
    async onConfirmedDeleteTaskCard() {
      this.deleteTaskCardRequesting = true
      await this.apiDeleteTaskCard({
        projectId: this.projectId,
        id: this.taskCardId
      })
      this.deleteTaskCardRequesting = this.deleteTaskCardModal = false
      if (!this.httpError) this.onClickBackButton()
    },
    async onClickUpdateTaskCard() {
      this.updateTaskCardRequesting = true
      await this.apiPutTaskCard({
        projectId: this.projectId,
        id: this.taskCardId,
        attributes: this.editTaskCard
      })
      this.updateTaskCardRequesting = false
    },
    ...mapActions({
      apiGetProject: 'entities/projects/show',
      apiGetProjectChatPosts: 'projectChatPosts/index',
      apiGetTaskLists: 'entities/taskLists/index',
      apiGetTaskCard: 'entities/taskCards/show',
      apiPutTaskCard: 'entities/taskCards/update',
      apiGetTaskCardHistories: 'entities/taskCardHistories/index',
      apiDeleteTaskCard: 'entities/taskCards/destroy',
      apiPutUserNotificationToRead: 'entities/userNotifications/updateToRead'
    })
  },
  beforeDestroy() {
    this.$refs.postsWrapper.removeEventListener('scroll', this.onScrollPostsWrapper)
  },
  async created() {
    if (!this.project) {
      await this.apiGetProject(this.projectId)
      if (!this.project) {
        this.$router.push({ name: 'project' })
        return
      }
    }

    await this.apiGetTaskCard({
      projectId: this.projectId,
      id: this.taskCardId
    })
    if (!this.taskCard) {
      return
    }

    this.editTaskCard = Object.assign(TaskCard.skeleton(), this.taskCard)

    GroupChatPost.delete(groupChatPost => {
      return groupChatPost.taskCardId == this.taskCardId
    })

    TaskCardHistory.delete(taskCardHistory => {
      return taskCardHistory.taskCardId == this.taskCardId
    })

    await this.apiGetTaskLists(this.projectId)

    await this.apiGetTaskCardHistories({
      projectId: this.projectId,
      taskCardId: this.taskCardId
    })
    this.$refs.historiesWrapper.removeEventListener('scroll', this.onScrollHistoriesWrapper)
    this.$refs.historiesWrapper.addEventListener('scroll', this.onScrollHistoriesWrapper)

    await this.apiGetProjectChatPosts({
      projectId: this.projectId,
      taskCardId: this.taskCardId
    })
    this.$refs.postsWrapper.removeEventListener('scroll', this.onScrollPostsWrapper)
    this.$refs.postsWrapper.addEventListener('scroll', this.onScrollPostsWrapper)

    if (this.taskCard.userNotificationId) this.apiPutUserNotificationToRead(this.taskCard.userNotificationId)
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.task-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-basis: 60%;
  text-align: center;
}

.task-card-item {
  position: relative;
  cursor: pointer;
  width: 26px;
  height: 26px;
  padding: 3px;
  margin-left: 10px;
  border-radius: 4px;
  display: flex;

  &:hover {
    background-color: $background-color;
  }

  img {
    width: 100%;
    height: 100%;
  }
}

.task-card-edit-menu {
  position: absolute;
  z-index: 2;
  top: 40px;
  right: 0;
  width: 250px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 0px 4px #00000026;

  .menu {
    cursor: pointer;
    padding: 10px;
    font-size: 13px;

    &:hover {
      background-color: $light-gray-color;
    }
  }
}

.task-card-content-wrapper {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;

  @include mq(md) {
    flex-direction: row;
  }
}

.task-card-content, .task-card-related-information {
  @include mq(md) {
    flex-basis: 50%;
  }
}

.task-card-content {
  border-bottom: 1px solid $dark-border-color;

  @include mq(md) {
    border-bottom: none;
    border-right: 1px solid $dark-border-color;
  }

  .task-card-flex-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    .task-card-flex-item {
      position: relative;
      flex-grow: 1;
      .table-attributes-wrapper {
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        @include mq(md) {
          position: absolute;
          height: 100%;
          width: 100%;
        }
        .table-attributes {
          width: 100%;

          tr {
            display: flex;
            padding: 15px 20px;

            &:not(:last-child) {
              border-bottom: 1px solid $dark-border-color;
            }

            @include mq(md) {
              display: table-row;
              padding: 0;
            }
          }

          th {
            display: block;
            width: 100%;
            padding: 0;
            font-weight: 600;

            @include mq(md) {
              display: table-cell;
              width: 1px;
              white-space: nowrap;
              padding: 20px 50px 20px 20px;
            }

            span {
              cursor: pointer;
              img {
                width: 22px;
                height: 22px;
                margin: 0 5px 2px 0;
              }
            }
          }

          td {
            display: block;
            width: 100%;
            padding: 0;
            word-break: break-all;

            @include mq(md) {
              display: table-cell;
              width: auto;
              padding: 20px 20px 20px 0;
            }

            .overdue {
              color: $error-color;
            }

            .add-member-button {
              margin-bottom: 5px;
              @include mq(sm) {
                margin-right: 10px;
              }
            }
          }
        }

        .members {
          flex-grow: 1;
          position: relative;
          min-height: 200px;

          .members-scroll-wrapper {
            position: absolute;
            height: 100%;
            width: 100%;
            padding-left: 20px;
            display: flex;
            flex-direction: column;

            .member {
              margin-bottom: 10px;

              &:last-child::after {
                content: '';
                display: block;
                height: 20px;
              }
            }
          }
        }
      }
    }
  }
}

.task-card-related-information {
  display: flex;
  flex-direction: column;
  min-height: 600px;

  @include mq(md) {
    min-height: 100%;
  }

  .tab-wrapper {
    display: flex;
    border-bottom: 1px solid $dark-border-color;
    z-index: 1;
    min-height: 36px;

    .tab-menu {
      font-size: 13px;
      font-weight: 600;
      color: $light-text-color;
      border-bottom: 4px solid $light-gray-color;
      padding: 15px;
      cursor: pointer;
      word-break: keep-all;

      &:first-child {
        margin-left: 0;
        padding-left: 15px;

        @include mq(md) {
          margin-left: 15px;
        }
      }

      &.active {
        color: $primary-color;
        border-bottom: 4px solid $primary-color;
      }
    }
  }

  .menu-wrapper {
    flex-grow: 1;
    padding: 10px 0 10px 20px;
  }

  .chat-posts-flex-container, .histories-flex-container {
    height: 100%;
    display: flex;
    flex-direction: column;

    .posts-wrapper {
      flex-direction: column;
      margin-left: -20px;
    }

    .histories-flex-item {
      position: relative;
      flex-grow: 1;
      margin-bottom: 10px;

      .histories-wrapper {
        position: absolute;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;

        .history-loading {
          text-align: center;
          padding: 10px;
          font-weight: 600;
          color: $light-text-color;
        }
      }
    }

    .task-card-history {
      padding: 10px 0;
    }
  }
}

.edit-task-card-card-footer {
  position: fixed;
  bottom: 0;
  z-index: 1001;
  display: flex;
  justify-content: flex-end;
  height: 0;
  width: 100%;
  background-color: #fff;
  padding: 0 20px;
  transition: all 0.5s;
  overflow: hidden;
  @include mq(md) {
    position: static;
  }
}

.display-card-footer {
  height: 85px;
  padding: 20px;
  border-top: 1px solid $dark-border-color;
  @include mq(md) {
    height: 95px;
  }
}
</style>
